<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>生活助學金申請</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>助學金管理系統</span></li>
          <li><span>工讀生管理</span></li>
          <li><span>生活助學金申請</span></li>
        </ol>
      </div>
    </header>
    <div class="main">
      <section class="panel" v-if="isShowTreaty">
        <treaty :key="$route.fullPath" type="life-workstudy"></treaty>
      </section>
      <section class="panel" v-else>
        <div class="panel-body container-fluid">
          <div class="row form-group">
            <div class="col-md-3 form-group">
              <label for="name" class="col-sm-4 col-xs-2 column-required">姓名</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.name}}</div>
              <div v-else class="col-sm-8 col-xs-10">
                <input id="name" name="name" v-validate="'required'" v-model="stu.name" type="text" class="form-control" maxlength="20"/>
                <span class="text-danger" v-show="errors.has('name')">{{ errors.first('name') }}</span>
              </div>
            </div>
            <div class="col-md-3 form-group">
              <label for="sex" class="col-sm-4 col-xs-2 column-required">性別</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.sex == 'M' ? '男' : '女'}}</div>
              <div v-else class="col-sm-8 col-xs-10">
                <select id="sex" name="sex" ref="sex" v-validate="'required'" v-model="stu.sex" class="form-control">
                  <option value="">請選擇</option>
                  <option value="M">男</option>
                  <option value="F">女</option>
                </select>
                <span class="text-danger" v-show="errors.has('sex')">{{ errors.first('sex') }}</span>
              </div>
            </div>
            <div class="col-md-3 form-group">
              <label for="account" class="col-sm-4 col-xs-2">學號</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.account}}</div>
              <div v-else-if="isAdminUser" class="col-sm-8 col-xs-10">
                <input id="account" name="account" v-model="stu.account" type="text" class="form-control" @input="getLastYearData"/>
              </div>
            </div>
            <div class="col-md-3 form-group">
              <label for="idno" class="col-sm-4 col-xs-2 column-required">身分證字號</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.idno}}</div>
              <div v-else class="col-sm-8 col-xs-10">
                <input id="idno" name="idno" v-validate="'required|idnoSex:sex'" @change="changeDataGetStuBase" v-model="stu.idno" type="text" class="form-control" maxlength="10"/>
                <span class="text-danger" v-show="errors.has('idno')">{{ errors.first('idno') }}</span>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-3 form-group">
              <label for="ssym" class="col-sm-4 col-xs-2">學制</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">
                {{ssymList.some(ssym => ssym.commCode == stu.ssym) ?
                ssymList.filter(ssym => ssym.commCode == stu.ssym)[0].commValue :
                ''}}
              </div>
              <div v-else class="col-sm-8 col-xs-10">
                <select id="ssym" name="ssym" v-model="stu.ssym" class="form-control">
                  <option value="">請選擇</option>
                  <option v-for="(item,key) in ssymList" :key="key" :value="item.commCode">{{ item.commValue }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-3 form-group">
              <label for="dept" class="col-sm-4 col-xs-2">科系</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">
                {{deptList.some(dept => dept.commCode == stu.dept) ?
                deptList.filter(dept => dept.commCode == stu.dept)[0].commValue :
                ''}}
              </div>
              <div v-else class="col-sm-8 col-xs-10">
                <select id="dept" name="dept" v-model="stu.dept" class="form-control">
                  <option value="">請選擇</option>
                  <option v-for="(item,key) in deptList" :key="key" :value="item.commCode">{{ item.commValue }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-3 form-group">
              <label for="drade" class="col-sm-4 col-xs-2">年級</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">
                {{dradeList.some(drade => drade.key == stu.drade) ?
                dradeList.filter(drade => drade.key == stu.drade)[0].value :
                ''}}
              </div>
              <div v-else class="col-sm-8 col-xs-10">
                <select id="drade" name="drade" v-model="stu.drade" class="form-control">
                  <option value="">請選擇</option>
                  <option v-for="(item,key) in dradeList" :key="key" :value="item.key">{{ item.value }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-3 form-group">
              <label for="dradeClass" class="col-sm-4 col-xs-2">班級</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">
                {{dradeClassList.some(dradeClass => dradeClass.key == stu.dradeClass) ?
                dradeClassList.filter(dradeClass => dradeClass.key == stu.dradeClass)[0].value :
                ''}}
              </div>
              <div v-else class="col-sm-8 col-xs-10">
                <select id="dradeClass" name="dradeClass" v-model="stu.dradeClass" class="form-control">
                  <option value="">請選擇</option>
                  <option v-for="(item,key) in dradeClassList" :key="key" :value="item.key">{{ item.value }}
                  </option>
                </select>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-3 form-group">
              <label for="state" class="col-sm-4 col-xs-2">在學狀態</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">
                {{uStateList.some(uState => uState.commCode == stu.state) ?
                uStateList.filter(uState => uState.commCode == stu.state)[0].commValue :
                ''}}
              </div>
              <div v-else class="col-sm-8 col-xs-10">
                <select id="state" name="state" v-model="stu.state" class="form-control" disabled>
                  <option value="">請選擇</option>
                  <option v-for="(item,key) in uStateList" :key="key" :value="item.commCode">{{ item.commValue }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-md-3 form-group">
              <label for="entryYear" class="col-sm-4 col-xs-2">入學年</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.entryYear}}</div>
              <div v-else class="col-sm-8 col-xs-10">
                <input id="entryYear" name="entryYear" v-model="stu.entryYear" type="number" class="form-control" />
              </div>
            </div>
            <div class="col-md-3 form-group">
              <label for="entryMonth" class="col-sm-4 col-xs-2">入學月</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.entryMonth}}</div>
              <div v-else class="col-sm-8 col-xs-10">
                <input id="entryMonth" name="entryMonth" v-model="stu.entryMonth" type="number" class="form-control" />
              </div>
            </div>
            <div class="col-md-3 form-group">
              <label for="phone" class="col-sm-4 col-xs-2">行動電話</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.phone}}</div>
              <div v-else class="col-sm-8 col-xs-10">
                <input id="phone" name="phone" v-model="stu.phone" type="text" class="form-control" />
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-6 form-group">
              <label for="schMail" class="col-sm-2 col-xs-2">學校信箱</label>
              <div v-if="isInfo" class="col-sm-8 col-xs-10">{{stu.schMail}}</div>
              <div v-else class="col-sm-10 col-xs-10">
                <input id="schMail" name="schMail" v-model="stu.schMail" type="email" class="form-control" />
              </div>
            </div>
            <div class="col-md-6 form-group">
              <label for="extMail" class="col-sm-2 col-xs-2 column-required">個人信箱</label>
              <div v-if="!isEditable" class="col-sm-8 col-xs-10">{{stu.extMail}}</div>
              <div v-else class="col-sm-10 col-xs-10">
                <input id="extMail" name="extMail" v-validate="'required'" v-model="stu.extMail" type="email" class="form-control" />
                <span class="text-danger" v-show="errors.has('extMail')">{{ errors.first('extMail') }}</span>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-12 form-group" v-if="isInfo">
              <label class="col-xs-3">地址</label>
              <div class="col-xs-9 col-md-10">
                {{ stu.resiFullAddress }}
              </div>
            </div>
            <div class="col-md-12 form-group" v-else>
              <label class="col-xs-2 col-md-1 form-group">地址</label>
              <div class="col-xs-3 col-md-2 form-group">
                <select v-model="stu.resiCityId" name="resiCityId"  class="form-control" @change="getResiArea()">
                  <option disabled value="">請選擇</option>
                  <option v-for="(item,key) in cityList" :key="key" :value="item.cityId">{{ item.cityName }}
                  </option>
                </select>
              </div>
              <div class="col-xs-3 col-md-2 form-group">
                <select v-model="stu.resiAreaId" name="resiAreaId"  class="form-control">
                  <option disabled value="">請選擇</option>
                  <option v-for="(item,key) in areaList" :key="key" :value="item.areaId">{{ item.areaName }}
                  </option>
                </select>
              </div>
              <div class="col-xs-offset-util-3 col-xs-9 col-md-7 form-group">
                <input type="text" id="resiAddr" name="resiAddr" class="form-control" v-model="stu.resiAddr" placeholder="地址" maxlength="100"/>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="col-md-4 form-group">
              <label for="reliefType" class="col-sm-4 col-xs-2 column-required">申請類別</label>
              <div class="col-sm-8 col-xs-10">
                <select id="applyType" name="applyType" v-validate="'required'" v-model="apply.applyType" class="form-control" :disabled="!isEditable" @change="checkApplyType()">
                  <option value="">請選擇</option>
                  <option v-for="(item,key) in applyTypeList" :key="key" :value="item.commCode">{{ item.commValue }}
                  </option>
                </select>
                <span class="text-danger" v-show="errors.has('applyType')">{{ errors.first('applyType') }}</span>
              </div>
            </div>
          </div>
          <div class="row form-group" v-if="(approveFileType == 9 || approveFileType == 2) && (apply.applyType == 1 || apply.applyType == 2 || apply.applyType == 3 || apply.applyType == 4 || apply.applyType == 6)">
            <div class="col-md-9 form-group">
              <label for="proveFile" class="col-sm-4 col-xs-2 column-required">上傳佐證資料<br/>{{getProveFileDescription()}}</label>
              <div v-if="proveFilePreview" class="col-sm-8 col-xs-10">
                <div>
                  {{ apply.proveFile }}
                  <a v-if="isEditable" type="button" @click="() => {proveFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
                </div>
                <a v-if="IsPdf(apply.proveFile)" :href="getPreviewUrl(apply.proveFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
                <div v-else-if="IsValidPreviewExt(apply.proveFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
                  <a :href="getPreviewUrl(apply.proveFile)" target="_blank">
                    <img class="img-fluid" :src="getPreviewUrl(apply.proveFile)" alt="" style="width:200px; "/>
                  </a>
                </div>
              </div>
              <div v-else-if="isEditable" class="col-sm-8 col-xs-10">
                <input type="file" id="proveFile" name="proveFile" accept=".pdf,image/*"  @change="getProveFile($event)" v-validate="'required'" />
                <span class="text-danger" v-show="errors.has('proveFile')">{{ errors.first('proveFile') }}</span>
              </div>
              <div v-else class="col-sm-8 col-xs-10">
                <div v-if="apply.proveFile">{{ apply.proveFile }}</div>
                <div v-else>未上傳檔案</div>
              </div>
            </div>
          </div>
          <div class="row form-group" v-if="approveFileType == 9 && (apply.applyType == 2 || apply.applyType == 5)">
            <div class="col-md-9 form-group">
              <label for="householdFile" class="col-sm-4 col-xs-2 column-required">
                3個月內戶籍謄本或新式戶口名簿上傳(皆含詳細記事)<br/>
                <a href="javascript:;" class="btn-link" @mouseover="display()" @mouseout="disappear()">上傳範例</a>
                <div id="box" class="box" style="z-index:1000;"><h4 class="blue">新式戶口名簿樣本</h4><img src="../../../../assets/images/1595926019829.jpg" width="500px"></div>
              </label>
              <div v-if="householdFilePreview" class="col-sm-8 col-xs-10">
                <div>
                  {{ apply.householdFile }}
                  <a v-if="isEditable" type="button" @click="() => {householdFilePreview = null}" style="color: #337ab7;cursor: pointer;">重傳檔案</a>
                </div>
                <a v-if="IsPdf(apply.householdFile)" :href="getPreviewUrl(apply.householdFile)" style="color: #337ab7" target="_blank">檔案預覽</a>
                <div v-else-if="IsValidPreviewExt(apply.householdFile)" class="col-xs-offset-util-2 col-xs-8 col-md-offset-util-2 col-md-8" >
                  <a :href="getPreviewUrl(apply.householdFile)" target="_blank">
                    <img class="img-fluid" :src="getPreviewUrl(apply.householdFile)" alt="" style="width:200px; "/>
                  </a>
                </div>
              </div>
              <div v-else-if="isEditable" class="col-sm-8 col-xs-10">
                <input type="file" id="householdFile" name="householdFile" accept=".pdf,image/*" @change="getHouseholdFile($event)" v-validate="'required'" />
                <span class="text-danger" v-show="errors.has('householdFile')">{{ errors.first('householdFile') }}</span>
              </div>
              <div v-else class="col-sm-8 col-xs-10">
                <div v-if="apply.householdFile">{{ apply.householdFile }}</div>
                <div v-else>未上傳檔案</div>
              </div>
            </div>
          </div>
          <div class="row form-group" v-if="approveFileType == 1">
            <div class="col-md-9 form-group">
              <label class="col-sm-4 col-xs-2" v-if="apply.applyType == 6">
                已申請弱勢助學金，免附證明文件
              </label>
              <label class="col-sm-4 col-xs-2" v-else>
                已申請學雜費減免，免附證明文件
              </label>
            </div>
          </div>
          <div class="row padi panel-relatio" v-if="(approveFileType == 9 || approveFileType == 2) && apply.applyType == 6">
            <div class="col-lg-12 form-group form-inline">
              <div class="col-lg-3">前一學期學業成績 : {{!!lastSmtrScore ? lastSmtrScore : '無資料'}}(未達60分無法申請)</div>
              <input name="radio" type="radio" value="new"  v-model="apply.scoreStatus"  :disabled="!isEditable">
              <label for="schoolState2"><span>新生免計成績</span></label>
              <input name="radio" type="radio" value="transfer"  v-model="apply.scoreStatus"  :disabled="!isEditable">
              <label for="schoolState2"><span>轉學生免計成績</span></label>
            </div>
          </div>
          <div class="row form-group">
            <div class="row padi panel-relatio">
              <div class="col-lg-12">
                <div class="col-lg-10">
                  <div class="col-lg-3">可服務時段</div>
                  <div class="col-lg-8" style="margin-left:2em;">
                    <div>
                      星期一：
                      <input value="monday89" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">8-9
                      <input value="monday910" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">9-10
                      <input value="monday1011" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">10-11
                      <input value="monday1112" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">11-12
                      <input value="monday1314" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">13-14
                      <input value="monday1415" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">14-15
                      <input value="monday1516" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">15-16
                      <input value="monday1617" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">16-17
                    </div>
                    <div>
                      星期二：
                      <input value="tuesday89" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">8-9
                      <input value="tuesday910" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">9-10
                      <input value="tuesday1011" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">10-11
                      <input value="tuesday1112" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">11-12
                      <input value="tuesday1314" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">13-14
                      <input value="tuesday1415" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">14-15
                      <input value="tuesday1516" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">15-16
                      <input value="tuesday1617" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">16-17
                    </div>
                    <div>
                      星期三：
                      <input value="wednesday89" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">8-9
                      <input value="wednesday910" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">9-10
                      <input value="wednesday1011" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">10-11
                      <input value="wednesday1112" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">11-12
                      <input value="wednesday1314" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">13-14
                      <input value="wednesday1415" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">14-15
                      <input value="wednesday1516" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">15-16
                      <input value="wednesday1617" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">16-17
                    </div>
                    <div>
                      星期四：
                      <input value="thursday89" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">8-9
                      <input value="thursday910" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">9-10
                      <input value="thursday1011" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">10-11
                      <input value="thursday1112" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">11-12
                      <input value="thursday1314" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">13-14
                      <input value="thursday1415" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">14-15
                      <input value="thursday1516" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">15-16
                      <input value="thursday1617" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">16-17
                    </div>
                    <div>
                      星期五：
                      <input value="friday89" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">8-9
                      <input value="friday910" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">9-10
                      <input value="friday1011" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">10-11
                      <input value="friday1112" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">11-12
                      <input value="friday1314" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">13-14
                      <input value="friday1415" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">14-15
                      <input value="friday1516" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">15-16
                      <input value="friday1617" v-model="apply.scheduleInfo" type="checkbox" :disabled="!isEditable">16-17
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="row padi panel-relatio">
              <div class="col-lg-12">
                <div class="col-lg-10">
                  <div class="col-lg-3">
                    <span>服務單位</span>
                  </div>
                  <div class="col-lg-2" style="margin-left:2em;"><input type="checkbox" v-model="apply.isApplyUnit" :disabled="!isEditable">已自行應徵服務單位</div>
                  <div class="col-lg-4">
                    <select class="form-control" name="applyUnit" v-validate="apply.isApplyUnit ? 'required' : ''" v-model="apply.applyUnit" :disabled="!isEditable">
                      <option value="">請選擇</option>
                      <option v-for="(item,key) in unitList" :key="key" :value="item.commCode">{{ item.commValue }}</option>
                    </select>
                    <span class="text-danger" v-show="errors.has('applyUnit')">{{ errors.first('applyUnit') }}</span>
                    <span class="unit-field-note">【注意，已取得該單位同意者方可填寫本欄位】</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row form-group">
            <div class="row padi panel-relatio">
              <div class="col-lg-12">
                <div class="col-lg-10">
                  <div class="col-lg-3">想要應徵的單位(最多兩個)</div>
                  <div class="col-lg-5" style="margin-left:2em;">
                    <multiselect
                      v-model="selectedDesiredUnits"
                      :options="unitList"
                      :multiple="true"
                      :max="maxDesiredUnits"
                      :close-on-select="false"
                      :clear-on-select="false"
                      :preserve-search="true"
                      :placeholder="isDesiredUnitsLocked ? '已填寫服務單位，不可再選擇' : '請選擇單位'"
                      label="commValue"
                      track-by="commCode"
                      :preselect-first="false"
                      selectedLabel="✔"
                      selectLabel=""
                      deselectLabel=""
                      :disabled="!isEditable || isDesiredUnitsLocked"
                    >
                      <template slot="maxElements">最多選擇 {{ maxDesiredUnits }} 個單位，請先移除已選項目再選擇其他單位。</template>
                    </multiselect>
                    <div v-if="isDesiredUnitsLocked" class="unit-lock-message">已填寫服務單位資料後，不可再填寫想要應徵的單位。</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr class="hrline">
          <div class="row form-group" v-if="this.$route.name == '/workstudy/life/apply'">
            <div class="row padi panel-relatio" style="margin-left:1.2em;">
              <h4 style="font-weight:1000">生活助學金服務須知</h4>
              <p>一、每週學習時數8小時為上限，每月不超過25小時，並參與教育訓練2場次，學習成效佳者發給生活助學金6,000元。<br>
                二、學生與學習單位排定服務學習時間，並依時報到，如需請假須先告知學習單位，並擇期補作，未依規定服務、未參與教育訓練或考核不佳者取消資格。<br>
                三、本人申請生活助學金措施，願意遵守相關規定如期服務，若有違反願接受學校處置。
              </p>
              <input type="checkbox" v-validate="'required'" id="agreement" name="agreement">同意
              <span class="text-danger" v-show="errors.has('agreement')">{{ errors.first('agreement') }}</span>
            </div>
          </div>
          <div v-if="isAdminUser && apply.schReviewState != '0' && !!apply.schReviewState" class="row form-group">
            <div class="col-sm-12">
              <label>隱私權及個人資料保護政策宣告：{{
                  (customFormatter(apply.crDate, "YYYY") - 1911) + customFormatter(apply.crDate, "年MM月DD日")
                }} 第{{ !!apply.privacyTreatyVersion ? apply.privacyTreatyVersion : "1.0" }}版</label>
            </div>
          </div>
          <div class="row form-group" v-if="apply.schReviewState != '0' && !!apply.schReviewState">
            <div class="col-sm-12">
              <h4 style="font-weight: bold;">審核結果</h4>
            </div>
          </div>
          <div class="row form-group" v-if="!!apply.schReviewState">
            <div class="col-sm-3" v-if="isAdminUser">
              <select id="schReviewState" name="schReviewState" v-validate="'required'" v-model="apply.schReviewState" class="form-control">
                <option v-for="(item,key) in schreviewStateList" :key="key" :value="item.commCode">{{ item.commValue }}
                </option>
              </select>
            </div>
            <div class="col-sm-12" v-else>
              <label>審核結果：{{ getReviewStateName(apply.schReviewState) }}</label>
            </div>
          </div>
          <div v-if="isQualifiedReviewState" class="row form-group">
            <div class="row padi panel-relatio">
              <div class="col-lg-12">
                <div class="col-lg-10">
                  <div class="col-lg-2">服務單位</div>
                  <template v-if="isAdminUser">
                    <div class="col-lg-1" style="margin-left:2em;"><input type="radio" value="Y" v-model="apply.applyStatus">錄取</div>
                    <div class="col-lg-2">
                      <select class="form-control" v-model="apply.acceptUnit">
                        <option value="">請選擇</option>
                        <option v-for="(item,key) in unitList" :key="key" :value="item.commCode">{{ item.commValue }}</option>
                      </select>
                    </div>
                    <div class="col-lg-4" style="margin-left:2em;"><input type="radio" value="N" v-model="apply.applyStatus">未錄取(最後沒有被任用的由生輔組註記未錄取)</div>
                  </template>
                  <template v-else-if="isUnitUser">
                    <div class="col-lg-1" style="margin-left:2em;"><input type="radio" value="Y" v-model="apply.applyStatus">錄取</div>
                    <div class="col-lg-2">
                      <select class="form-control" v-model="apply.acceptUnit" disabled>
                        <option value="">請選擇</option>
                        <option v-for="(item,key) in unitList" :key="key" :value="item.commCode">{{ item.commValue }}</option>
                      </select>
                    </div>
                  </template>
                  <template v-else>
                    <div class="col-lg-8" style="margin-left:2em;">{{ getApplyStatusText() }}</div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div v-if="apply.schReviewState == '3' || apply.schReviewState == '4' " class="row form-group">
            <div class="col-sm-12">
              <label for="schReviewContent">{{getReviewStateName(apply.schReviewState)}}說明</label>
              <textarea v-if="isAdminUser" id="schReviewContent" name="schReviewContent" v-model="apply.schReviewContent" rows="3" class="form-control">
						</textarea>
              <div v-else class="form-control-static">{{ apply.schReviewContent || '無' }}</div>
            </div>
            <hr/>
          </div>
          <div class="text-center form-group" v-if="isUnitUser">
            <button class="btn" v-if="JSON.stringify(this.sessionData) != '{}'" @click="gotoView('/workstudy/life/list')">返回</button>
            <button class="btn s_btn_o" @click="handleSave()" v-if="canUnitAssign">送出</button>
          </div>
          <div class="text-center form-group" v-else-if="(!apply.schReviewState ||apply.schReviewState == '4')">
            <button class="btn" v-if="JSON.stringify(this.sessionData) != '{}'" @click="gotoView('/workstudy/life/list')">返回</button>
            <button class="btn s_btn_o" @click="handleSave()">儲存</button>
          </div>
          <div class="text-center form-group" v-else>
            <button class="btn" v-if="JSON.stringify(this.sessionData) != '{}'" @click="gotoView('/workstudy/life/list')">返回</button>
            <button class="btn s_btn_o" @click="handleSave()" v-if="!apply.schReviewState || apply.schReviewState == '4' || isAdminUser">送出</button>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>
<script>
import treaty from "@/components/assist/treaty";
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
export default {
  components:{
    treaty,
    Multiselect
  },
  data(){
    return {
      stu: {
        idno: "",
        name: "",
        sex: "",
        account:"",
        ssym: "",
        dept: "",
        drade: "",
        dradeClass: "",
        state: "",
        entryYear: "",
        entryMonth: "",
        phone: "",
        schMail: "",
        extMail: "",
        resiAddr: "",
        resiCityId: "",
        resiAreaId: "",
        deptCode: "",
      },
      apply:{
        id: "",
        applyType: "",
        proveFile: "",
        householdFile: "",
        schReviewState: "",
        schReviewContent: "",
        scheduleInfo: [],
        isApplyUnit: false,
        applyUnit: "",
        applyStatus: "",
        acceptUnit: "",
        crDate: "",
        scoreStatus: "",
        desiredUnits: [],
      },
      // 下拉選單來源
      ssymList: [],
      deptList: [],
      cityList: [],
      areaList: [],
      applyTypeList: [],
      schreviewStateList: [],
      unitList: [],
      dradeList: [
        {
          key: "1",
          value: "一年級"
        },
        {
          key: "2",
          value: "二年級"
        },
        {
          key: "3",
          value: "三年級"
        },
        {
          key: "4",
          value: "四年級"
        },
        {
          key: "5",
          value: "五年級"
        },
        {
          key: "6",
          value: "六年級"
        },
        {
          key: "7",
          value: "七年級"
        },
        {
          key: "8",
          value: "八年級"
        },
        {
          key: "9",
          value: "九年級"
        }
      ],
      dradeClassList: [
        {
          key: "A",
          value: "A班"
        },
        {
          key: "B",
          value: "B班"
        },
        {
          key: "C",
          value: "C班"
        },
        {
          key: "D",
          value: "D班"
        },
      ],
      uStateList: [],
      //檔案
      proveFile: "",
      householdFile: "",
      proveFilePreview: "",
      householdFilePreview: "",
      // 是否顯示條約
      isShowTreaty: false,
      approveFileType: null,
      lastSmtrScore: null,
      isFromIdnoSearch: false,
      originalAcceptUnit: ""
    }

  },
  mounted(){
    if(this.$route.name == "/workstudy/life/apply") {
      this.isShowTreaty = true;
    }
    this.pageInit();
  },
  methods:{
    pageInit(){
      console.log(this.isAdminUser);
      console.log(this.isUnitUser);
      let api = `/api/lifeworkstudyapply/editInit?isNew=${this.$route.name == "/workstudy/life/apply"}`;
      this.$axios.get(api).then(res => {
        if (res.data.status == "success") {
          this.ssymList = res.data.data.selectList.ssym
          this.deptList = res.data.data.selectList.dept
          this.cityList = res.data.data.selectList.city
          this.applyTypeList = res.data.data.selectList.applyType
          this.schreviewStateList = res.data.data.selectList.reviewState
          this.uStateList = res.data.data.selectList.uState
          this.unitList = res.data.data.selectList.unit
          if (this.getStore(this.$route.name) != null) {
            let storeData = JSON.parse(this.getStore(this.$route.name));
            if(storeData.isFromIdnoSearch != "") {
              this.isFromIdnoSearch = storeData.isFromIdnoSearch
            }

            if(storeData.applyId != ""){
              api = `/api/lifeworkstudyapply/${storeData.applyId}${this.buildAnonymousAccessQuery(storeData.idNo, !!storeData.isFromIdnoSearch)}`;
              this.$axios.get(api).then(res => {
                if (res.data.status !== "success") {
                  this.handleDetailLoadError(res.data.msg);
                  return;
                }
                this.applyDetailData(res.data.data);
              });
            }
          }


          if (this.$route.path == "/workstudy/life/apply" && this.sessionData.accountType == "STU"){
            this.stu = {
              ...res.data.data.stu,
              ssym: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(0,1) : "",
              dept: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(1,2) : ""
            };
          }
        } else if(res.data.status == "error"){
          bootbox.alert(res.data.msg);
          this.$router.back();
        }
      });
    },
    applyDetailData(detailData) {
      this.stu = {
        ...detailData.stu,
        ssym: detailData.stu.deptCode ? detailData.stu.deptCode.substr(0,1) : "",
        dept: detailData.stu.deptCode ? detailData.stu.deptCode.substr(1,2) : ""
      };
      this.apply = {
        ...detailData.ra,
        scheduleInfo: detailData.ra.scheduleInfo == null ? [] : JSON.parse(detailData.ra.scheduleInfo),
        desiredUnits: detailData.ra.desiredUnits == null ? [] : JSON.parse(detailData.ra.desiredUnits)
      };
      this.originalAcceptUnit = this.apply.acceptUnit || "";

      if (this.isUnitUser && this.isQualifiedReviewState && !this.isUnitAssignmentLocked && this.currentUnitCode) {
        this.apply.applyStatus = "Y";
        this.apply.acceptUnit = this.currentUnitCode;
      }

      this.checkApplyType();

      this.proveFilePreview = this.getPreviewUrl(this.apply.proveFile);
      this.householdFilePreview = this.getPreviewUrl(this.apply.householdFile);
    },
    handleDetailLoadError(msg) {
      const alertMessage = msg || "查無資料";
      bootbox.alert(alertMessage, () => {
        if (this.isUnitUser) {
          this.gotoView('/workstudy/life/list', {});
        } else {
          this.$router.back();
        }
      });
    },
    handleSave(withoutPrint = false){
      if (this.isUnitUser) {
        this.handleUpdate(withoutPrint);
        return;
      }
      this.$validator.validateAll().then((result) => {
        if (result) {
          if(this.apply.id === ""){
            this.handleCreate(withoutPrint)
          } else {
            this.handleUpdate(withoutPrint);
          }
        }
      });
    },
    handleCreate() {
      const api = "/api/lifeworkstudyapply";
      let formData = new FormData();

      this.syncDesiredUnits();
      this.stu.deptCode = this.stu.ssym + this.stu.dept;
      if(!(this.stu.deptCode.length == 0 || this.stu.deptCode.length == 3)) {
        bootbox.alert("學制及科系請兩項都填寫或是都留空");
        return;
      }

      if(this.approveFileType != 1 && this.apply.applyType == 6 && this.apply.scoreStatus == "" && this.lastSmtrScore < 60) {
        bootbox.alert("請選擇免計成績原因");
        return;
      }

      for(let key in this.stu) {
        if(this.stu[key]) {
          formData.append(`stu.${key}`, this.stu[key]);
        }
      }
      for(let key in this.apply) {
        if(this.apply[key]) {
          if(key == "scheduleInfo" || key == "desiredUnits") {
            formData.append(`apply.${key}`, JSON.stringify(this.apply[key]));
          }else if(typeof(this.apply[key]) === "object") {
            if(Array.isArray(this.apply[key])) {
              for(let i = 0; i < this.apply[key].length; i++) {
                for(let k in this.apply[key][i]) {
                  if(this.apply[key][i][k]) {
                    formData.append(`apply.${key}[${i}].${k}`, this.apply[key][i][k]);
                  }
                }
              }
            } else {
              formData.append(`apply.${key}`, JSON.stringify(this.apply[key]));
            }
          } else {
            formData.append(`apply.${key}`, this.apply[key]);
          }
        }
      }

      formData.append("householdFile", this.householdFile)
      formData.append("proveFile", this.proveFile)
      this.$axios.post(api, formData).then(res => {
        if(res.data.status === "success") {
          this.apply.id = res.data.data.id;
          this.apply.smtr = res.data.data.smtr;
          this.apply.crDate = res.data.data.crDate;
          bootbox.alert("申請成功。<br/>");
          this.gotoView('/workstudy/life/list', {idNo: this.stu.idno});
        } else if(res.data.status === "error") {
          bootbox.alert(res.data.msg);
        }
      });
    },
    buildUnitAssignFormData() {
      let formData = new FormData();

      // 單位端只送錄取欄位，避免誤送其他資料
      if (this.apply.applyStatus) {
        formData.append("apply.applyStatus", this.apply.applyStatus);
      }
      if (this.apply.acceptUnit) {
        formData.append("apply.acceptUnit", this.apply.acceptUnit);
      }

      return formData;
    },
    buildAnonymousAccessQuery(idNo = this.stu.idno, isFromIdnoSearch = this.isFromIdnoSearch) {
      if (!isFromIdnoSearch || !idNo) {
        return "";
      }

      const query = new URLSearchParams({ idNo }).toString();
      return query ? `?${query}` : "";
    },
    handleUpdate() {
        const api = `/api/lifeworkstudyapply/${this.apply.id}${this.buildAnonymousAccessQuery()}`;

        if (this.isUnitUser) {
          if (!this.canUnitAssign) {
            if (this.isUnitAssignmentLocked) {
              bootbox.alert("案件已被其他單位錄取，無法修改");
            } else if (!this.currentUnitCode) {
              bootbox.alert("尚未選擇單位，無法錄取");
            } else {
              bootbox.alert("目前案件狀態不可錄取");
            }
            return;
          }

          const formData = this.buildUnitAssignFormData();
          const unitName = this.currentUnitName || this.currentUnitCode;

          bootbox.confirm(`確認要將此學生錄取到「${unitName}」嗎？`, (confirmed) => {
            if (!confirmed) {
              return;
            }

            this.$axios.post(api, formData).then(res => {
              if(res.data.status === "success") {
                bootbox.alert("儲存成功。<br/>");
                this.gotoView('/workstudy/life/list', {});
              } else if(res.data.status === "error") {
                bootbox.alert(res.data.msg);
              }
            });
          });
          return;
        }

        let formData = new FormData();

        this.syncDesiredUnits();
        this.stu.deptCode = this.stu.ssym + this.stu.dept;
        if(!(this.stu.deptCode.length == 0 || this.stu.deptCode.length == 3)) {
          bootbox.alert("學制及科系請兩項都填寫或是都留空");
          return;
        }

        if(this.approveFileType != 1 && this.apply.applyType == 6 && this.apply.scoreStatus == "" && this.lastSmtrScore < 60) {
          bootbox.alert("請選擇免計成績原因");
          return;
        }

        for(let key in this.stu) {
          if(this.stu[key]) {
            formData.append(`stu.${key}`, this.stu[key]);
          }
        }

        for(let key in this.apply) {
          if(this.apply[key]) {
            if(key == "scheduleInfo" || key == "desiredUnits") {
              formData.append(`apply.${key}`, JSON.stringify(this.apply[key]));
            }else if(typeof(this.apply[key]) === "object") {
              if(Array.isArray(this.apply[key])) {
                for(let i = 0; i < this.apply[key].length; i++) {
                  for(let k in this.apply[key][i]) {
                    if(this.apply[key][i][k]) {
                      formData.append(`apply.${key}[${i}].${k}`, this.apply[key][i][k]);
                    }
                  }
                }
              } else {
                formData.append(`apply.${key}`, JSON.stringify(this.apply[key]));
              }
            } else {
              formData.append(`apply.${key}`, this.apply[key]);
            }
          }
        }

        formData.append("householdFile", this.householdFile);
        formData.append("proveFile", this.proveFile);
        this.$axios.post(api, formData).then(res => {
          if(res.data.status === "success") {
            bootbox.alert("儲存成功。<br/>");
            if(!this.isAdminUser) {
              this.gotoView('/workstudy/life/list', {idNo: this.stu.idno});
            } else {
              this.gotoView('/workstudy/life/list', {});
            }
          } else if(res.data.status === "error") {
            bootbox.alert(res.data.msg);
          }
        });
    },
    getHouseholdFile(event) {
      this.householdFile = event.target.files[0];
      if(this.householdFile){
        if(this.checkFileExtension(this.householdFile.name, ["jpg","jpeg","png","pdf"])){
          this.apply.householdFile = this.householdFile.name;
          if (/^image/.test(this.householdFile.type)){
            this.compresImage(this.householdFile).then(result => {
              this.householdFile = result;
            });
          }
        }else{
          bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
          this.householdFile = null;
        }
      }else{
        bootbox.alert("上傳失敗，請重新上傳。");
      }

    },
    getProveFile(event) {
      this.proveFile = event.target.files[0];
      if(this.proveFile){
        if(this.checkFileExtension(this.proveFile.name, ["jpg","jpeg","png","pdf"])){
          this.apply.proveFile = this.proveFile.name;
          if (/^image/.test(this.proveFile.type)){
            this.compresImage(this.proveFile).then(result => {
              this.proveFile = result;
            });
          }
        }else{
          bootbox.alert("請上傳，下列格式: jpg, jpeg, png, pdf");
          this.proveFile = null;
        }
      }else{
        bootbox.alert("上傳失敗，請重新上傳。");
      }

    },
    getProveFileDescription() {
      switch(this.apply.applyType) {
        case "1":
          return "身心障礙手冊或身心障礙學生鑑輔會證明文件（查驗正本，繳交影本）"
        case "2":
          return "身心障礙手冊或身心障礙學生鑑輔會證明文件（查驗正本，繳交影本）"
        case "3":
          return "低收入戶證明文件（須有學生名字）"
        case "4":
          return "中低收入戶證明文件（須有學生名字）";
        case "6":
          return "家庭(父、母、學生)最近年度所得及財產清單(國稅局申請)"
      }
      return "";
    },
    async getResiArea(resiAreaId = "") {
      this.stu.resiAreaId = "";
      this.stu.resiRoadId = "";
      this.stu.resiAreaList = [];
      this.stu.resiRoadList = [];
      const api = "/api/Common/getArea/" + this.stu.resiCityId;
      let resp = await this.$axios.post(api);
      if(resp.data.status == "success"){
        this.areaList = resp.data.data.areaList;
        this.stu.resiAreaId = resiAreaId;
      }
    },
    IsPdf(filePath) {
      if(filePath != null && filePath != ""){
        var ext = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
        if(ext == "pdf"){
          return true;
        }else{
          return false;
        }
      }
      return false;
    },
    IsValidPreviewExt(filePath) {
      if(filePath != null && filePath != ""){
        var ext = filePath.substring(filePath.lastIndexOf('.') + 1).toLowerCase();
        if(ext == "jpg" || ext == "jpeg" || ext == "png" || ext == "pdf"){
          return true;
        }else{
          return false;
        }
      }
      return false;
    },
    getPreviewUrl(filePath) {
      let url = "";
      if(this.IsValidPreviewExt(filePath)) {
        url = "/upload/" + filePath;
      }
      return url;
    },
    getUnitName(unitCode) {
      if (!unitCode) {
        return "";
      }

      const unit = this.unitList.find(item => item.commCode == unitCode);
      return unit ? unit.commValue : unitCode;
    },
    getReviewStateName(reviewState) {
      const state = this.schreviewStateList.find(item => item.commCode == reviewState);
      return state ? state.commValue : "";
    },
    getApplyStatusText() {
      if (this.apply.applyStatus == "Y") {
        return `錄取單位：${this.getUnitName(this.apply.acceptUnit)}`;
      }
      if (this.apply.applyStatus == "N") {
        return "未錄取";
      }
      return "尚未設定服務單位結果";
    },
    syncDesiredUnits() {
      if (this.isDesiredUnitsLocked && this.apply.desiredUnits.length > 0) {
        this.apply.desiredUnits = [];
      }
    },
    display() {
      document.getElementById("box").style.display = "block";
    },
    disappear() {
      document.getElementById("box").style.display = "none";
    },
    checkApplyType(){
      let api = `/api/lifeworkstudyapply/checkApplyType`;
      this.$axios.post(api, {
        idno: this.stu.idno,
        account: this.stu.account,
        smtr: this.apply.smtr,
        applyType: this.apply.applyType
      }).then(res => {
        this.approveFileType = res.data.data.status;
        if(this.approveFileType == 3) {
          bootbox.alert("上學期成績未滿 60 分，無法申請生活助學金。");
          this.gotoView('/workstudy/life/list');
        }
        this.lastSmtrScore = res.data.data.score;
      });
    },
    changeDataGetStuBase() {
      if (!this.isAdminUser && this.stu.idno.length == 10) {
        const api = `/api/lifeworkstudyapply/studIsExists/${this.stu.idno}`;
        const _this = this;
        this.$axios.post(api).then(resp=>{
          if(resp.data.status != "success"){
            bootbox.alert(resp.data.msg, function(){
              _this.$router.replace({ name: "index" });
            });
          }
        });

      }
    },
    getLastYearData() {
      if(this.isAdminUser && this.stu.account.length == 9) {
        let api = `/api/lifeworkstudyapply/lastYearData?account=${this.stu.account}`;
        this.$axios.get(api).then(res => {
          if (res.data.status == "success") {
            if(res.data.data != null){
              this.stu = {
                ...res.data.data.stu,
                ssym: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(0,1) : "",
                dept: res.data.data.stu.deptCode ? res.data.data.stu.deptCode.substr(1,2) : ""
              };
              if(this.stu.resiAreaId) {
                this.getResiArea(this.stu.resiAreaId);
              }
            }
          } else if(res.data.status == "error"){
            bootbox.alert(res.data.msg);
            this.$router.back();
          }
        });
      }
    },
  },
  computed: {
    isAdminUser(){
      return this.isAdmin('stipendMage');
    },
    isUnitUser(){
      return !this.isAdminUser && this.sessionData.accountType === "TCH";
    },
    isQualifiedReviewState(){
      return this.apply.schReviewState === "2" || this.apply.schReviewState === "5";
    },
    currentUnitCode(){
      return this.sessionData.deptCode || "";
    },
    currentUnitName(){
      return this.getUnitName(this.currentUnitCode);
    },
    isUnitAssignmentLocked(){
      return this.isUnitUser && !!this.originalAcceptUnit
    },
    canUnitAssign(){
      return this.isUnitUser && !!this.apply.id && this.isQualifiedReviewState && !this.isUnitAssignmentLocked && !!this.currentUnitCode;
    },
    isInfo(){
      if (this.isUnitUser) {
        return true;
      }

      return this.$route.path != "/workstudy/life/apply" || this.sessionData.accountType == "STU";
    },
    isEditable(){
      if (this.isUnitUser) {
        return false;
      }

      // 管理員在待審狀態可以編輯
      // 申請人或透過身分證查詢在草稿或待補件狀態可以編輯
      return (this.isAdminUser && (this.apply.schReviewState == "1")) ||
        (this.sessionData.account == this.apply.account && this.apply.schReviewState == "4") ||
        (this.isFromIdnoSearch && this.apply.schReviewState == "4") ||
        (!this.apply.schReviewState);
    },
    maxDesiredUnits(){
      return 2;
    },
    isDesiredUnitsLocked(){
      return !!this.apply.applyUnit;
    },
    selectedDesiredUnits:{
      get(){
        return this.unitList.filter(item => this.apply.desiredUnits.includes(item.commCode));
      },
      set(val){
        this.apply.desiredUnits = val.map(item => item.commCode);
      }
    }
  },
  watch:{
    "apply.applyStatus": function (val) {
      if (val === "N") {
        this.apply.acceptUnit = "";
      }
    },
    "apply.applyUnit": function () {
      this.syncDesiredUnits();
    },
    "stu.idno": function (val) {
      if(val && val != this.stu.idno){
        this.stu.idno = val.toUpperCase();
        if(val.length == 10) {
          const api = `/api/relief/isStuExists/${val}`;
          var _this = this;
          this.$axios.post(api).then(resp => {
            if (resp.data.status == "success") {
            } else {
              bootbox.alert(resp.data.msg, function () {
                _this.$router.replace({name: "index"});
              });
            }
          });
        }
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.removeStore(this.$route.name);
    next();
  }
}
</script>
<style scoped>
::v-deep .multiselect {
  min-height: 34px;
  font-size: 14px;
}
::v-deep .multiselect__tags {
  min-height: 34px;
  padding: 4px 40px 4px 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
}
::v-deep .multiselect__tags .multiselect__tag {
  background: #0088cc;
  color: #fff;
  margin-bottom: 2px;
  padding: 3px 26px 3px 8px;
  font-size: 13px;
}
::v-deep .multiselect__tags .multiselect__tag-icon:after {
  color: #fff;
}
::v-deep .multiselect__tags .multiselect__tag-icon:hover {
  background: #006da3;
}
::v-deep .multiselect__select {
  height: 32px;
}
::v-deep .multiselect__placeholder {
  color: #999;
  padding-top: 2px;
  margin-bottom: 0;
  font-size: 14px;
}
::v-deep .multiselect__input,
::v-deep .multiselect__single {
  font-size: 14px;
  padding: 0;
  margin-bottom: 0;
  line-height: 24px;
}
::v-deep .multiselect__option--highlight {
  background: #0088cc;
}
::v-deep .multiselect__option--highlight::after {
  background: #0088cc;
}
.unit-field-title {
  display: flex;
  align-items: center;
  gap: 8px;
}
.unit-field-note {
  color: #d9534f;
  font-size: 14px;
  font-weight: 700;
}
.unit-lock-message {
  margin-top: 6px;
  color: #d9534f;
  font-size: 13px;
}
</style>
